const waitlistComponentLoaders = Object.freeze({
  'waitlist.workspace': async () => {
    const module = await import('./waitlist-workspace-component.js');
    return module.WaitlistWorkspaceComponent;
  },
});

export default waitlistComponentLoaders;
